import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import BoardTotalOfComment from "./BoardTotalOfComment";
import { useBoard } from "../../../providers/BoardDetailProvider";
import LikeButton from "../../molecules/LikeButton";

const BoardFooter = () => {
  const {
    state: { boardDetailData },
    updateLikedBoardStatus,
  } = useBoard();
  const { total_of_likes = 0, like_flg = 0, id = 0 } = boardDetailData ?? {};
  const onLikeBoardSuccess = () => {
    updateLikedBoardStatus(Number(!like_flg), true);
  };
  return (
    <div className={`${STBoardDetail.boardFooter}`}>
      <LikeButton
        rootId={id}
        likeFlg={like_flg}
        totalOfLikes={total_of_likes}
        onSuccess={onLikeBoardSuccess}
      />
      <BoardTotalOfComment />
    </div>
  );
};

export default BoardFooter;
